/* tslint:disable */
/* eslint-disable */
/**
 * crm-screener-api
 * crm-screener-api
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { ShadowDecision } from './ShadowDecision';
import {
    ShadowDecisionFromJSON,
    ShadowDecisionFromJSONTyped,
    ShadowDecisionToJSON,
} from './ShadowDecision';

/**
 * 
 * @export
 * @interface GetShadowDecision200Response
 */
export interface GetShadowDecision200Response {
    /**
     * 
     * @type {ShadowDecision}
     * @memberof GetShadowDecision200Response
     */
    data?: ShadowDecision;
}

/**
 * Check if a given object implements the GetShadowDecision200Response interface.
 */
export function instanceOfGetShadowDecision200Response(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function GetShadowDecision200ResponseFromJSON(json: any): GetShadowDecision200Response {
    return GetShadowDecision200ResponseFromJSONTyped(json, false);
}

export function GetShadowDecision200ResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): GetShadowDecision200Response {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'data': !exists(json, 'data') ? undefined : ShadowDecisionFromJSON(json['data']),
    };
}

export function GetShadowDecision200ResponseToJSON(value?: GetShadowDecision200Response | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'data': ShadowDecisionToJSON(value.data),
    };
}

